// React Router and Material UI components
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Dialog, DialogActions, TextField, DialogContent, DialogTitle, Button, Grid, Container } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// added components
import Header from "./header";
import { useDispatch } from "react-redux";
import { verifyEmailLandingAsync } from "../../../../features/actions/auth";
import MDInput from "components/MDInput";
// images
import logoMain from "assets/images/logo-main.svg";
import worldIcon from "assets/images/small-logos/world-icon.svg";
import messageIcon from "assets/images/small-logos/message-icon.svg";
import callIcon from "assets/images/small-logos/call-icon.svg";
import showHideIcon from "assets/images/small-logos/show-hide-icon.svg";
import dontShowIcon from "assets/images/small-logos/dont-show.svg";
import PageLayout from "examples/LayoutContainers/PageLayout";
import correctIcon from "assets/images/small-logos/icon-right.svg";
import wrongIcon from "assets/images/small-logos/wrong-icon.svg";
import { Typography } from "@mui/material";
function EmailVerification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;

  const email = search?.split("?email=");
  const [openModal, setOpenModal] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [typing, setTyping] = useState(false);
  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  })
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  })
  const checkPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).*$/;
  const hasUpperCase = (str) => /[A-Z]/.test(str);
  const hasLowerCase = (str) => /[a-z]/.test(str);
  const hasNumber = (str) => /[0-9]/.test(str);
  const hasSpecialChar = (str) =>
    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(str);
  const isLongEnough = (str) => str.length >= 8;
  const eyeButton = () => {
    setShowPassword(!showPassword);
  };

  const eyeButton2 = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const inputHandler = (fieldName) => {
    return (e) => {
      const { name, value } = e.target;
      let error = "";

      switch (fieldName) {
        case "password":

          if (value && !checkPassword.test(value)) {
            error = "Password format is incorrect";
            setShowPassword(false)

          } else if (value.length < 8) {
            error = "Minimum 8 characters required";
            setShowPassword(false)

          }
          break;
        case "confirmPassword":
          console.log(value, values)
          if (!value && !(value === values.password)) {
            error = "Confirm Password is required.";
            setShowPassword(false)
          } else if (!(value === values.password)) {
            error = "password doesn't match.";
            setShowPassword(false)

          }
        default:
          break;
      }

      setErrors({ ...errors, [fieldName]: error });
      setValues({ ...values, [fieldName]: value });
    };
  };



  const handleClick = () => {
    if (email?.[1]) {
      const password = values.password;
      dispatch(verifyEmailLandingAsync({ email: email?.[1], password }));
      navigate("/sign-in");
    }

  };

  return (
    <>
      <Header />
      <PageLayout>
        <Dialog open={openModal} maxWidth="sm" fullWidth>
          <DialogTitle style={{paddingBottom:0}}>
            <MDTypography variant="h4" fontWeight="medium" p={0} textAlign="center" color="#212121"  mt={1}>
            Please Set Your Password
            </MDTypography>
          </DialogTitle>
          <DialogContent mt={0} pt={0}>
            <MDTypography variant="button" color="text" pt={0} >
             
            <p style={{textAlign:"center" , pt:"0px"}}> Kindly set your password to gain access to the portal.</p> 
            </MDTypography>

            <Grid
              item
              xs={12}
              lg={6}
              sx={{
                alignSelf: "start",
                justifyContent: "start",
                height: "100%",
              }}
            >
              <MDBox p={1} mt={1} sx={{ position: "relative" }}>
                <MDInput
                  type={showPassword ? "text" : "password"}
                  placeholder="Password *"
                  value={values.password}
                  error={!!errors.password}
                  onChange={inputHandler("password")}
                  onFocus={() => setTyping(true)}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      borderRadius: "45px",
                      border: "1px solid #9095A4",
                    },
                  }}
                />

                <MDBox
                  sx={{
                    position: "absolute",
                    right: "20px",
                    top: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() => eyeButton()}
                >
                  {showPassword ? (
                    <img src={showHideIcon} alt="icon" />
                  ) : (
                    <img src={dontShowIcon} alt="icon" />
                  )}
                </MDBox>
              </MDBox>

              {errors.password ? (
                <MDTypography
                  px={1}
                  sx={{
                    fontSize: "13px",
                    fontWeight: "400",
                    lineHeight: "15px",
                  }}
                  color="error"
                >
                  {errors.password}
                </MDTypography>
              ) : null}
            </Grid>

            <Grid
              item
              xs={12}
              lg={6}
              sx={{
                alignSelf: "start",
                justifyContent: "start",
                height: "100%",
              }}
            >
              {values.password && errors.password === "" ? (
                <>
                  <MDBox p={1} mt={1} sx={{ position: "relative" }}>
                    <MDInput
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password *"
                      value={values.confirmPassword}
                      error={!!errors.confirmPassword}
                      onChange={inputHandler("confirmPassword")}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: "45px",
                          border: "1px solid #9095A4",
                        },
                      }}
                    />
                    <MDBox
                      sx={{
                        position: "absolute",
                        right: "20px",
                        top: "15px",
                        cursor: "pointer",
                      }}
                      onClick={() => eyeButton2()}
                    >
                      {showConfirmPassword ? (
                        <img src={showHideIcon} alt="icon" />
                      ) : (
                        <img src={dontShowIcon} alt="icon" />
                      )}
                    </MDBox>
                  </MDBox>
                  {errors.confirmPassword ? (
                    <MDTypography
                      px={1}
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        lineHeight: "15px",
                      }}
                      color="error"
                    >
                      {errors.confirmPassword}
                    </MDTypography>
                  ) : null}
                </>
              ) : null}
            </Grid>

           {typing ? (
                    <Grid paddingLeft={2} item xs={12} className="password-validations">
                      <MDBox sx={{ my: 2, px: 1 }} >
                        <MDBox sx={{ display: "flex" }}>
                          <MDBox sx={{ mr: 0.5 , mt:1}}>
                            <img
                              src={
                                isLongEnough(values.password)
                                  ? correctIcon
                                  : wrongIcon
                              }
                            />
                          </MDBox>
                          <Typography
                            className={
                              isLongEnough(values.password)
                                ? "password-checker-after"
                                : "password-checker-before"
                            }
                          >
                            Must be at least 8 characters long
                          </Typography>
                        </MDBox>

                        <MDBox sx={{ display: "flex" }}>
                          <MDBox sx={{ mr: 0.5,mt:1 }}>
                            <img
                              src={
                                hasUpperCase(values.password)
                                  ? correctIcon
                                  : wrongIcon
                              }
                            />
                          </MDBox>
                          <Typography
                            className={
                              hasUpperCase(values.password)
                                ? "password-checker-after"
                                : "password-checker-before"
                            }
                          >
                            Include at least 1 uppercase letter
                          </Typography>
                        </MDBox>
                        <MDBox sx={{ display: "flex" }}>
                          <MDBox sx={{ mr: 0.5 , mt:1 }}>
                            <img
                              src={
                                hasLowerCase(values.password)
                                  ? correctIcon
                                  : wrongIcon
                              }
                            />
                          </MDBox>
                          <Typography
                            className={
                              hasLowerCase(values.password)
                                ? "password-checker-after"
                                : "password-checker-before"
                            }
                          >
                            Include at least 1 lowercase letter
                          </Typography>
                        </MDBox>

                        <MDBox sx={{ display: "flex" }}>
                          <MDBox sx={{ mr: 0.5 , mt:1 }}>
                            <img
                              src={
                                hasNumber(values.password)
                                  ? correctIcon
                                  : wrongIcon
                              }
                            />
                          </MDBox>
                          <Typography
                            className={
                              hasNumber(values.password)
                                ? "password-checker-after"
                                : "password-checker-before"
                            }
                          >
                            Include at least 1 number
                          </Typography>
                        </MDBox>

                        <MDBox sx={{ display: "flex" }}>
                          <MDBox sx={{ mr: 0.5 , mt:1}}>
                            <img
                              src={
                                hasSpecialChar(values.password)
                                  ? correctIcon
                                  : wrongIcon
                              }
                            />
                          </MDBox>
                          <Typography
                            className={
                              hasSpecialChar(values.password)
                                ? "password-checker-after"
                                : "password-checker-before"
                            }
                          >
                            Include at least 1 special character (!@#$%^&*){" "}
                          </Typography>
                        </MDBox>
                      </MDBox>
                    </Grid>
                  ) : null}



            <MDBox display="flex" justifyContent="center" alignItems="center" fullWidth mt={4}>
              <MDButton
                onClick={handleClick}
                sx={{
                  color: "#FFFFFF",
                  border: "2px solid transparent",
                  padding: "12px 24px 12px 24px",
                  borderRadius: "188px",
                  ml: 2,
                  background: "linear-gradient(63.54deg, #49A3F1 -5.54%, #1A73E8 100%)",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  textAlign: "left",
                  fontFamily: "Urbanist",
                }}
              >
                Submit
              </MDButton>
            </MDBox>
          </DialogContent>
          <DialogActions>

          </DialogActions>
        </Dialog>
      </PageLayout>

      <MDBox sx={{ backgroundColor: "#318BEC", py: 5 }}>
        <Container sx={{ '@media (min-width:1580px)': { maxWidth: '1600px!important' } }}>
          <Grid container>
            <Grid item xxl={4} lg={3} md={6}>
              <MDBox sx={{ display: "flex", alignItems: "start", flexDirection: "column", justifyContent: "start" }}>
                <MDBox>
                  <img src={logoMain} alt="logo" />
                </MDBox>
              </MDBox>
            </Grid>

            <Grid item xxl={3} lg={4} md={6}>
              <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MDBox sx={{ mr: 0.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src={worldIcon} alt="icon" />
                  </MDBox>

                  <MDBox>
                    <MDTypography variant="button" sx={{ color: "#ffffff", fontSize: "16px", lineHeight: "19px", fontWeight: "700" }}>
                      WWW.GRATITUDESYSTEMS.COM
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item lg={3} md={6}>
              <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MDBox sx={{ mr: 0.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src={messageIcon} alt="icon" />
                  </MDBox>

                  <MDBox>
                    <MDTypography variant="button" sx={{ color: "#ffffff", fontSize: "16px", lineHeight: "19px", fontWeight: "700" }}>
                      INFO@GRATITUDESYSTEMS.COM
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>

            <Grid item lg={2} md={6}>
              <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MDBox sx={{ mr: 0, display: "flex", alignItems: "center", justifyContent: "center", pr: 0 }}>
                    <img src={callIcon} alt="icon" />
                  </MDBox>

                  <MDBox>
                    <MDTypography variant="button" sx={{ color: "#ffffff", fontSize: "16px", lineHeight: "19px", fontWeight: "700" }}>
                      (202)240-7754
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </Container>
      </MDBox>
    </>
  );
}

export default EmailVerification;
